// Self-hosted (fe/public/hdri/) instead of drei's default raw.githack.com mirror — that CDN is
// explicitly not meant for production traffic and periodically 429s under real-world load
// (Sentry ECRANIFY-FE-5). Files are the same drei-assets HDRIs, downloaded once.
export const DREI_HDRI_CDN = '/hdri/'

export const DREI_PRESETS: Record<string, string> = {
  apartment: 'lebombo_1k.hdr',
  city: 'potsdamer_platz_1k.hdr',
  dawn: 'kiara_1_dawn_1k.hdr',
  forest: 'forest_slope_1k.hdr',
  lobby: 'st_fagans_interior_1k.hdr',
  night: 'dikhololo_night_1k.hdr',
  park: 'rooitou_park_1k.hdr',
  studio: 'studio_small_03_1k.hdr',
  sunset: 'venice_sunset_1k.hdr',
  warehouse: 'empty_warehouse_01_1k.hdr',
}
